export enum EChartIndicator {
  TI_MA = 'TI_MA',
  TI_SAR = 'TI_SAR',
  TI_BOLL = 'TI_BOLL',
  TI_MACD = 'TI_MACD',
  TI_CCI = 'TI_CCI',
  TI_RSI = 'TI_RSI',
  TI_SD = 'TI_SD',
  TI_SO = 'TI_SO',
  TI_ATR = 'TI_ATR',
  TI_EMA = 'TI_EMA',
  TI_WMA = 'TI_WMA',
  TI_WEMA = 'TI_WEMA',
  TI_FIBONACCI = 'TI_FIBONACCI',
  TI_ICHIMOKU = 'TI_ICHIMOKU',
  TI_ADX = 'TI_ADX',
  TI_HEIKINASHI = 'TI_HEIKINASHI',
  TI_STOCHASTIC = 'TI_STOCHASTIC',
  TI_WILLIAMSR = 'TI_WILLIAMSR'
}

export enum EColumnPreferenceOrderType {
  OPEN_POSITION = 'OPEN_POSITION',
  PENDING_ORDER = 'PENDING_ORDER',
  ORDER_HISTORY = 'ORDER_HISTORY',
  // Order History sub table type
  POSITION_HISTORY = 'POSITION_HISTORY',
  ORDERS_AND_DEALS = 'ORDERS_AND_DEALS',
  ORDER_HISTORY_CENTROID = 'ORDER_HISTORY_CENTROID'
}

export enum EColumnPreferenceOrderHistoryType {
  POSITION_HISTORY = 'POSITION_HISTORY',
  ORDERS_AND_DEALS = 'ORDERS_AND_DEALS',
  ORDER_HISTORY_CENTROID = 'ORDER_HISTORY_CENTROID'
}

export enum EColumnPreferenceType {
  PROFIT_AND_LOSS = 'PROFIT_AND_LOSS',
  VOLUME = 'VOLUME',
  UNITS = 'UNITS',
  ENTRY_PRICE = 'ENTRY_PRICE',
  CURRENT_PRICE = 'CURRENT_PRICE',
  TAKE_PROFIT = 'TAKE_PROFIT',
  STOP_LOSS = 'STOP_LOSS',
  STOP_LOSS_IN_POINTS = 'STOP_LOSS_IN_POINTS',
  SWAP = 'SWAP',
  FILL_POLICY = 'FILL_POLICY',
  EXPIRY = 'EXPIRY',
  EXPIRY_DATE = 'EXPIRY_DATE',
  PENDING_PRICE = 'PENDING_PRICE',
  CLOSE_PRICE = 'CLOSE_PRICE',
  COMMISSION = 'COMISSION',
  REMARKS = 'REMARKS',
  STATE = 'STATE',
  SIZE = 'SIZE',
  POTENTIAL_LOSS = 'POTENTIAL_LOSS',
  POTENTIAL_GAIN = 'POTENTIAL_GAIN',
  RISK_REWARD = 'RISK_REWARD',
  MARGIN_USED = 'MARGIN_USED',
  // Centroid
  AVG_FILLED_PRICE = 'AVG_FILLED_PRICE',
  PRICE = 'PRICE',
  FILL_VOLUME = 'FILL_VOLUME',
  VALIDITY = 'VALIDITY',
  DEVIATION = 'DEVIATION',
  NOTIONAL = 'NOTIONAL',
  CURRENCY = 'CURRENCY',
  CENTROID_OPEN_ORDER = 'CENTROID_OPEN_ORDER',
  CENTROID_CLOSE_ORDER = 'CENTROID_CLOSE_ORDER',
  CLOSE_DATE = 'CLOSE_DATE'
}

export enum EUserPreferenceCategory {
  LINE_DRAWING = 'LINE_DRAWING',
  ONE_CLICK_TRADING = 'ONE_CLICK_TRADING',
  SWAP_UNITS = 'SWAP_UNITS',
  PRE_TRADE_PIN = 'PRE_TRADE_PIN',
  CANDLESTICK = 'CANDLESTICK',
  MARKET = 'MARKET',
  CALENDAR = 'CALENDAR'
}

export enum EUserPreferenceType {
  OCT_ENABLE = 'OCT_ENABLE',
  LINE_DRAWING = 'LINE_DRAWING',
  SWAP_UNITS = 'SWAP_UNITS',
  PTP_ENABLE = 'PTP_ENABLE',
  CANDLESTICK_COLOR = 'CANDLESTICK_COLOR',
  HIDE_OTHER_SYMBOLS = 'HIDE_OTHER_SYMBOLS',
  // Calendar
  IMPACT_LEVEL = 'IMPACT_LEVEL',
  EVENT_CATEGORIES = 'EVENT_CATEGORIES',
  EVENT_COUNTRIES = 'EVENT_COUNTRIES',
  NOTIFICATION_STATUS = 'NOTIFICATION_STATUS',
  FORECAST_DATA_DISPLAY = 'FORECAST_DATA_DISPLAY'
}

export enum EOrderTableColumn {
  VOLUME = 'VOLUME',
  UNITS = 'UNITS',
  ENTRY_PRICE = 'ENTRY_PRICE',
  CURRENT_PRICE = 'CURRENT_PRICE',
  TAKE_PROFIT = 'TAKE_PROFIT',
  STOP_LOSS = 'STOP_LOSS',
  SWAP = 'SWAP',
  FILL_POLICY = 'FILL_POLICY',
  EXPIRY = 'EXPIRY',
  EXPIRY_DATE = 'EXPIRY_DATE',
  PENDING_PRICE = 'PENDING_PRICE',
  CLOSE_PRICE = 'CLOSE_PRICE',
  COMMISSION = 'COMMISSION',
  REMARKS = 'REMARKS',
  STATE = 'STATE',
  SIZE = 'SIZE',
  // Centroid
  AVG_FILLED_PRICE = 'AVG_FILLED_PRICE',
  PRICE = 'PRICE',
  FILL_VOLUME = 'FILL_VOLUME',
  VALIDITY = 'VALIDITY',
  DEVIATION = 'DEVIATION',
  NOTIONAL = 'NOTIONAL',
  CURRENCY = 'CURRENCY',
  CENTROID_OPEN_ORDER = 'CENTROID_OPEN_ORDER',
  CENTROID_CLOSE_ORDER = 'CENTROID_CLOSE_ORDER',
  CLOSE_DATE = 'CLOSE_DATE',
  // Horizon
  BID = 'BID',
  ASK = 'ASK',
  LAST = 'LAST',
  PERCENT_CHANGE = 'PERCENT_CHANGE',
  OPEN_INT = 'OPEN_INT',
  IMP_VOLUME = 'IMP_VOLUME',
  DELTA = 'DELTA',
  GAMMA = 'GAMMA',
  VEGA = 'VEGA',
  THETA = 'THETA',
  LAST_PRICE = 'LAST_PRICE',
  AVG_BOUGHT_PRICE = 'AVG_BOUGHT_PRICE',
  AVG_SOLD_PRICE = 'AVG_SOLD_PRICE',
  PROFIT_AND_LOSS = 'PROFIT_AND_LOSS',
  MARKET_VALUE = 'MARKET_VALUE',
  ORDER_TYPE = 'ORDER_TYPE',
  ORDER_STATUS = 'ORDER_STATUS',
  LIMIT_PRICE = 'LIMIT_PRICE',
  STOP_PRICE = 'STOP_PRICE',
  PLACED_QUANTITY = 'PLACED_QUANTITY',
  FILLED_QUANTITY = 'FILLED_QUANTITY',
  REMAINING_QUANTITY = 'REMAINING_QUANTITY',
  TIME_IN_FORCE = 'TIME_IN_FORCE',
  ORDER_NO = 'ORDER_NO'
}
